<div class="loading" [hidden]="!isLoading">
  <div class="loader">Loading...</div>
</div>
<div class="modal-header">
  <div>
    <h4 class="modal-title" id="myModalLabel">
      Assign Clients for <strong>{{ accountant.user.full_name }}</strong>
    </h4>
    <p>
      Click and assign a
      <i class="feather check" style="font-weight: 700; color: #0084ff"></i> to
      each client that you want to assign to a staff member.
    </p>
  </div>
  <button
    type="button"
    class="btn-close"
    (click)="bsModalRef.hide()"
    aria-label="Close"
  >
    <i class="feather x"></i>
  </button>
</div>
<div class="modal-body modal-body-assignments scrollbars">
  <table
    class="table table-borderless table-striped highlight-columns table-assigments border-mobile"
  >
    <!-- Lista de accountants -->
    <thead class="fixed">
      <tr>
        <th></th>
        <th
          *ngFor="let accountant of accountants"
          [hidden]="accountant.access_level == 1"
          class="text-center"
        >
          <div class="fixed-th">
            &nbsp;&nbsp;{{ accountant.user.full_name }}&nbsp;&nbsp;
          </div>
        </th>
      </tr>
    </thead>
    <thead class="default">
      <tr>
        <th style="height: 46px">
          <div class="thead-left">
            <div
              *ngFor="let client of clients | activeClientsOnly; let i = index"
              style="max-width: 40vw; overflow: hidden; text-overflow: ellipsis"
            >
              {{ client.name }}
            </div>
          </div>
        </th>
        <th
          *ngFor="let accountant of accountants"
          class="text-center"
          [hidden]="accountant.access_level == 1"
        >
          <div class="fixed-th" *ngIf="accountant.access_level != 1">
            &nbsp;&nbsp;{{ accountant.user.full_name }}&nbsp;&nbsp;
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let client of clients | activeClientsOnly; let i = index">
        <th
          style="
            max-width: 40vw;
            overflow: hidden;
            text-overflow: ellipsis;
            height: 46px;
          "
        >
          {{ client.name }}
        </th>
        <td
          class="text-center"
          *ngFor="let acc of accountants; let z = index"
          (click)="z == 0 ? toggleClient(client, acc) : return"
          [hidden]="acc.access_level == 1"
        >
          <i
            class="feather check"
            [ngClass]="{
              active: findAccountants(client.accountants, acc.user.id) == true,
            }"
          ></i>
        </td>
      </tr>
    </tbody>
  </table>

  <a
    class="btn btn-primary-light"
    style="margin: 30px 0px 0px 0px"
    (click)="loadMore()"
    *ngIf="!isLoading"
    >Load More</a
  >
</div>
<div class="modal-footer">
  <div class="row">
    <div class="col-4 text-left">
      <button type="button" class="btn btn-default" (click)="bsModalRef.hide()">
        Cancel
      </button>
    </div>
    <div class="col-8">
      <button type="button" class="btn btn-primary" (click)="saveAssignments()">
        Save changes
      </button>
    </div>
  </div>
</div>
